import 'css-chunksrc/client/pages/calendarPage/styles.scss';export default {
  "calendarPage": "_calendarPage_eix1s_1",
  "header": "_header_eix1s_9",
  "profileNavigation": "_profileNavigation_eix1s_21",
  "main": "_main_eix1s_31",
  "loader": "_loader_eix1s_40",
  "loaderMain": "_loaderMain_eix1s_48",
  "calendar": "_calendar_eix1s_1"
};